import { Checkbox } from "antd";
import { useMemo } from "react";
import type { LabelValue } from "~types/labelValue";
import { SELECT_ALL_VALUE } from "../constants/ui";

import "./PermissionFieldCheckboxGroup.scss";

type PermissionFieldSelectProps = {
  value?: string[];
  options: LabelValue[];
  disabled: boolean;
  onChange: (value: string[]) => void;
};

const PermissionFieldCheckboxGroup = ({ value, options, disabled, onChange }: PermissionFieldSelectProps) => {
  const allValues = useMemo(() => options.map(({ value }) => value), [options]);
  const isAllSelected = useMemo(() => value?.find((item) => item === SELECT_ALL_VALUE), [value]);

  const handleChange = (values: string[]) => {
    let actualValue: string[];

    // if all currently selected and something changed - unselect all option or unselect everything if select all got unchecked
    if (isAllSelected) {
      const allSelectedIndex = values.indexOf(SELECT_ALL_VALUE);
      actualValue = allSelectedIndex > -1 ? values.toSpliced(allSelectedIndex, 1) : [];
    } else {
      // if selected all except "all" option or clicked "all" option - select all options
      if (values.length === options.length - 1 || values.find((item) => item === SELECT_ALL_VALUE)) {
        actualValue = allValues;
      } else {
        actualValue = values;
      }
    }
    onChange(actualValue);
  };

  return (
    <Checkbox.Group className="permissions-checkboxgroup" value={value} options={options} disabled={disabled} onChange={handleChange} />
  );
};

export default PermissionFieldCheckboxGroup;
